import { render, staticRenderFns } from "./UploadedApps.vue?vue&type=template&id=fdd33cda"
import script from "./UploadedApps.vue?vue&type=script&lang=js"
export * from "./UploadedApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports